import { TResponseSuccess } from 'app/Requests/types';
import { apiRoutes } from 'auth/utils/apiRoutes';
import { toast } from 'react-toastify';
import history from './history';
import { _t } from './i18n';
import {
  getAccessTokenFromLocalStorage,
  getFromLocalStorage,
  setInLocalStorage,
} from './localStorage';
import { path } from './path';
import { TObj, TValueRecord } from './types';
import html2pdf from 'html-to-pdf-js';

export const disableInputs = (
  filtersInputs: any[],
  dimmedInputs: string[],
): any[] => {
  return filtersInputs.map((input) =>
    dimmedInputs.includes(input.name) ? { ...input, isDimmed: true } : input,
  );
};
export const hideInputs = (
  filtersInputs: any[],
  dimmedInputs: string[],
): any[] => {
  return filtersInputs.map((input) =>
    dimmedInputs.includes(input.name)
      ? { ...input, isDelete: true, size: 'none' }
      : input,
  );
};

export const handleChangeHeight: (
  evt: React.ChangeEvent<HTMLTextAreaElement>,
) => void = (evt) => {
  evt.target.style.height = '0px';
  const scrollHeight = evt.target.scrollHeight;
  evt.target.style.height = scrollHeight + 'px';
};

// export const resizingTextareaInput = (e: React.ChangeEvent<any>) => {
//   e.target.style.height = e.target.offsetHeight;
//   if (e.target.scrollHeight > e.target.offsetHeight) {
//     e.target.style.height = e.target.scrollHeight + 'px';
//   }
// };

// export const resizingTextInput = (e: React.ChangeEvent<any>) => {
//   e.target.style.height = '32.5px';
//   e.target.style.height = e.target.scrollHeight + 'px';
// };

export const handelUrlID: (url: any) => void = (url) =>
  url?.split('=')?.[1] ||
  url?.split('.be/')?.[1] ||
  url?.split('/shorts/')?.[1];

export const handleFilterMainTable: (
  tableRef: any,
  key: string,
  value: any,
  selectInput?: any,
  ExtraVal?: { key: string; value: any },
) => void = (tableRef, key, value, selectInput, ExtraVal) => {
  const isArr = Array.isArray(value);

  let newVal = value;
  if (isArr) {
    if (tableRef?.current?.filters[key])
      newVal = [...tableRef?.current?.filters[key], ...value];

    //using map to make sure all the values arr unique
    const myMap = new Map(newVal.map((item: any) => [item?.value, item]));

    newVal = [...myMap].map(([_, value]) => value);
  }

  tableRef?.current?.onChangeFilter(key)(newVal);
  if (ExtraVal) {
    tableRef?.current?.onChangeFilter(ExtraVal?.key)(ExtraVal?.value);
  }

  setTimeout(() => {
    tableRef?.current?.onSubmit();
    selectInput?.current?.commonProps?.setValue(newVal);
  }, 20);
};

export const graduationYearOpts = (): { label: string; value: number }[] => {
  const options = [];
  for (let i = 1950; i <= new Date().getFullYear() + 4; i++) {
    options.push({ label: `${i}`, value: i });
  }
  return options;
};

export const validateEndDate = (
  Date_options: { label: string; value: number }[],
  startDate: number,
) => {
  const newStartDate = Date_options.findIndex((date) => date.value === startDate);
  return Date_options.slice(newStartDate);
};

export const changeStackedColumnsPlatformResponseSchema = (
  customized_legend: string[],
  values: TValueRecord[],
): TValueRecord[] => {
  const platformTransformedValues: TValueRecord[] = [];
  customized_legend?.forEach((platform: string, index: number) => {
    const platformValues = values?.map(
      (item: TValueRecord) => item.data[index],
    );
    platformTransformedValues.push({
      name: platform,
      data: platformValues,
    });
  });
  return platformTransformedValues;
};
export const selectedItemsHasKey = (
  items: Record<string, any>,
  keyExtractor: string,
): unknown => {
  return Object.keys(items)
    .map((key) => items[key]?.[keyExtractor])
    .some((item) => item > 0);
};

export const onErrorHandler: (error: any, show: any) => void = (
  error,
  show,
) => {
  if (typeof error === 'string') {
    toast.error(`react-query error !! , ${error}`);
    throw new Error(`react-query error !! , ${error}`);
  }
  const { response } = error;
  const url: string = response?.config?.url;

  const keyWordsToDisplay404 = [
    'show',
    'view',
    'grabbing-status',
    'sets/words',
  ];

  const isDetailsPage = keyWordsToDisplay404?.some((key) => url?.includes(key));

  if (response?.request?.status === 404 && isDetailsPage) {
    history.push('/404');
    history.go(0);
    return;
  }

  if (response?.data?.errors) {
    const errorsKeys = Object.keys(response?.data?.errors);

    if (errorsKeys) {
      toast.error(
        errorsKeys
          .map(
            (item) =>
              ` ${_t('basic:' + item)}: ${response?.data?.errors[item][0]}` ||
              response?.data?.errors[item],
          )
          .join(','),
      );

      return false;
    }
  }

  const errors = response?.data?.errors;
  const message = response?.data?.message;
  if (response?.request?.status === 401) {
    show({
      isAlternative: true,
      autoHide: true,
      message,
    });

    return false;
  }

  if (response?.request?.status === 408) {
    if (!errors) toast.info(message);

    return false;
  }
  const token = getAccessTokenFromLocalStorage();
  if (
    response?.config.url === apiRoutes.refreshToken &&
    //4xx status codes
    Math.floor(response?.data?.code / 100) === 4 &&
    token
  ) {
    history.push(path.auth.REDIRECT_SIGN_IN);
    history.go(0);
    setInLocalStorage('access_token');
  }
  // if ([404, 500].includes(response?.request?.status) && isQuery) {
  //   if (!errors) toast.error(message);
  //   history.push(`/${response?.request?.status}`);
  //    history.go(0);

  //   return false;
  // }

  if (response?.data?.message && response?.request?.status !== 403) {
    toast.error(response?.data?.message);

    return false;
  }

  return false;
};

export const handelStatusError: (
  error: any,
  show: any,
  notAuthorizeCb?: any,
) => void = (error, show, notAuthorizeCb): any => {
  if (typeof error === 'string') {
    toast.error(`react-query error !! , ${error}`);
    throw new Error(`react-query error !! , ${error}`);
  }
  const { response } = error;
  if (response?.request?.status === 404) {
    history.push('/404');
    history.go(0);
    return;
  }
  if (response?.request?.status === 500) {
    history.push('/500');
    history.go(0);
    return;
  }

  if (response?.request?.status === 502) {
    history.push('/502');
    history.go(0);
    return;
  }

  if (response?.data?.errors) {
    const errorsKeys = Object.keys(response?.data?.errors);

    if (errorsKeys) {
      toast.error(
        errorsKeys
          .map(
            (item) =>
              ` ${_t('basic:' + item)}: ${response?.data?.errors[item][0]}` ||
              response?.data?.errors[item],
          )
          .join(','),
      );

      return false;
    }
  }

  const errors = response?.data?.errors;
  const message = response?.data?.message;
  if (response?.request?.status === 401) {
    show({
      isAlternative: true,
      autoHide: true,
      notAuthorizeCb: notAuthorizeCb,
      message,
    });
    return false;
  }

  if (response?.request?.status === 408) {
    if (!errors) toast.info(message);

    return false;
  }
  const token = getAccessTokenFromLocalStorage();
  if (
    response?.config.url === apiRoutes.refreshToken &&
    //4xx status codes
    Math.floor(response?.data?.code / 100) === 4 &&
    token
  ) {
    history.push(path.auth.REDIRECT_SIGN_IN);
    history.go(0);
    setInLocalStorage('access_token');
  }

  if (response?.data?.message && response?.request?.status !== 403) {
    toast.error(response?.data?.message);

    return false;
  }

  return false;
};

export const onSuccessHandler = (response: TResponseSuccess): any => {
  if (response?.successMessage) toast.success(response?.successMessage);
};

export const handleCleanObjFromFalsyValues = (object: TObj): TObj => {
  if (typeof object == 'undefined') return {};
  const clonedObj: TObj = {};
  Object.keys(object).forEach((key: string) => {
    if (object[key]) {
      clonedObj[key] = object[key];
    }
  });
  return clonedObj;
};

// remove the labels with value zero
export const handleFormatChartsData = (unFormatedData: {
  labels: [];
  series: [];
}): any => {
  const dataMap = new Map();

  unFormatedData?.series?.forEach((item, index) => {
    dataMap.set(unFormatedData.labels[index], item);
  });
  [...dataMap.keys()].forEach((item) => {
    if (dataMap.get(item) <= 0) dataMap.delete(item);
  });
  const formatedData = {
    labels: [...dataMap.keys()].slice(0, 10),
    series: [...dataMap.values()].slice(0, 10),
  };
  return formatedData;
};

export const handleTranslatedChartData = (unformatedData: {
  labels: string[];
  series: number[];
}): any => {
  const data = {
    ...unformatedData,
    labels: unformatedData?.labels?.map((e: any) =>
      typeof e === 'object' ? checkTranslated(e?.original, e?.arabic) : e,
    ),
  };
  return data;
};
export const handleDataForSummary = (unformatedData: {
  labels: string[];
  series: number[];
}): any => {
  const seriesTrnasform =
    unformatedData?.series?.length > 0
      ? unformatedData?.series?.map((item) =>
          Object.values(item).reduce((sum, value) => sum + value, 0),
        )
      : [];

  const data = {
    ...unformatedData,
    series: seriesTrnasform,
  };

  return data;
};
//check the translation of items
export const removeExtraSpaces = (str: string) => {
  return str?.toLowerCase()?.split(/\s+/).join(' ').trim();
};
const isEn = getFromLocalStorage('LNG') == 'en' ? true : false;
export const checkTranslated: (
  original: any,
  translated: any,
  activeTab?: any,
) => string = (original, translated, activeTab) => {
  let result = '';
  if (translated?.length && !activeTab?.length) {
    if (isEn) {
      result = original;
    } else {
      result = translated;
    }
  } else if (translated?.length && activeTab?.length) {
    if (activeTab === 'en') {
      result = original;
    } else {
      result = translated;
    }
  } else {
    result = original;
  }
  return result;
};

export const checkHoveringTranslated = (
  original: string,
  translated: string,
): string => {
  const isTranslated =
    translated?.length && original?.toLowerCase() !== translated?.toLowerCase();
  const result = isEn
    ? isTranslated
      ? translated
      : ''
    : isTranslated
      ? original
      : translated;
  return result;
};
export const checkToShowCreatedAt = (basetablaname: string): boolean => {
  switch (basetablaname) {
    case `hashtags/all-analyzed_/hashtags/hashtags_${_t('basic:analyzed')}`:
      return true;
    case `hashtags/all-un-analyzed_/hashtags/hashtags_${_t(
      'basic:un_analyzed',
    )}`:
      return true;
    case `topics/analyzed_/topics/topics-table_${_t('topics:topics')}`:
      return true;
  }

  return false;
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const checkHTML = function (html: string) {
  const doc = document.createElement('div');
  doc.innerHTML = html;
  return doc.innerHTML === html;
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function calculateAge(birthday: any) {
  birthday = new Date(birthday);
  const ageDifMs = Date.now() - birthday.getTime();
  const ageDate = new Date(ageDifMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export const module_name = 'HASHTAGS';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const handleDownloadPdf = async (
  path: string,
  id: string,
  name: string,
) => {
  const myWindow: any = window.open(path, id, 'popup,width=1250,height=1250');
  myWindow.onload = async function () {
    const spinner = document.createElement('div');
    const background = document.createElement('div');
    const text = document.createElement('p');
    spinner.classList.add('custLoader');
    text.classList.add('custLoaderText');
    background.classList.add('custLoaderBg');
    text.innerText = _t('basic:creating_your_PDF');
    const body = myWindow?.document.getElementById('body');
    body?.prepend(background);
    body?.prepend(spinner);
    body?.prepend(text);
    // const tooltip = document.querySelectorAll('.apexcharts-tooltip');
    // for (let index = 0; index < tooltip.length; index++) {
    //   tooltip[index].classList.add('hide');
    // }
    body?.classList?.add('hide');
    setTimeout(async function () {
      const element = myWindow?.document.getElementById(id);
      myWindow?.close();
      const opt = {
        margin: 5,
        filename: `${name}.pdf`,
        html2canvas: {
          useCORS: true,
          allowTaint: true,
          logging: false,
          scale: 3,
        },
        jsPDF: {
          orientation: 'l',
          unit: 'mm',
          format: 'a4',
          floatPrecision: 'smart',
        },
      };
      const newElement = element?.firstElementChild;
      newElement?.classList.add('pdf_container');
      await html2pdf().from(newElement).set(opt).save();
    }, 2000);
  };
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const handleDownloadPdfInCurrentPage = async (id: string) => {
  const element: any = document.getElementById(id);
  element.classList.add('pdf_container');
  const opt = {
    margin: 10,
    filename: `${id}.pdf`,
    html2canvas: {
      useCORS: true,
      allowTaint: true,
      logging: false,
      scale: 3,
    },
    jsPDF: {
      orientation: 'l',
      unit: 'mm',
      format: 'a4',
      floatPrecision: 'smart',
    },
  };
  await html2pdf().from(element).set(opt).save();
};
export const isItArabicText: (text: string) => any = (text) =>
  !/[^\u0600-\u06FF\u0020-\u0040\u005B-\u0060\u007B-\u007E]/.test(text);

export const getCurrentDate: () => string = () => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();
  return `${yyyy}-${mm}-${dd}`;
};

export const removeObjectOfIDs = (data: any) => {
  if (data.ids) {
    data = {
      ...data,
      ids: data.ids.map((item: any) =>
        typeof item === 'object' && 'current' in item ? item?.current : item,
      ),
    };
  }
  return data;
};
export function removeHash(text: string): string {
  if (text?.startsWith('#')) {
    return text?.slice(1);
  }
  return text;
}
